module.exports = __webpack_public_path__ + "img/patientCode.26543a60.png";